import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonComponent } from '../button/button.component';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
    selector: 'btn-confirm',
    imports: [ButtonComponent, TranslateModule, ConfirmPopupModule],
    templateUrl: './button-confirm.component.html',
    styleUrl: './button-confirm.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonConfirmComponent {
    private confirmationService = inject(ConfirmationService);
    private translateService = inject(TranslateService);

    id = input.required<string>();

    severity = input<'success' | 'warn' | 'danger' | 'primary'>('danger');
    size = input<'small' | 'large' | undefined>(undefined);
    text = input<boolean>(true);
    rounded = input<boolean>(true);
    outlined = input<boolean>(false);
    loading = input<boolean>(false);
    disabled = input<boolean>(false);

    label = input<string>('');
    icon = input<string>('');

    fullWidth = input<boolean>(false);

    message = input<string>('uiKit.buttons.buttonConfirm.confirmDelete');

    acceptLabel = input<string>('uiKit.buttons.buttonConfirm.acceptLabel');
    rejectLabel = input<string>('uiKit.buttons.buttonConfirm.rejectLabel');

    acceptStyleClass = input<string>('p-button-danger');
    rejectStyleClass = input<string>('p-button-outlined p-button-secondary');

    accept = output<void>();
    reject = output<void>();

    popconfirmIcon = computed(() => {
        switch (this.severity()) {
            case 'success':
                return 'fa-regular fa-circle-check';
            case 'warn':
                return 'fa-regular fa-triangle-exclamation';
            case 'danger':
                return 'fa-regular fa-do-not-enter';
            case 'primary':
                return 'fa-regular fa-circle-info';
        }
    });

    openPopconfirm(event: MouseEvent): void {
        this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: this.translateService.instant(this.message()),
            icon: this.popconfirmIcon(),
            key: `${this.id()}-btn`,
            rejectLabel: this.translateService.instant(this.rejectLabel()),
            acceptLabel: this.translateService.instant(this.acceptLabel()),
            rejectButtonStyleClass: this.rejectStyleClass(),
            acceptButtonStyleClass: this.acceptStyleClass(),
            accept: () => {
                this.accept.emit();
            },
            reject: () => {
                this.reject.emit();
            },
        });
    }
}
